import { retrieveData } from "../LocalConnection/LocalConnection";

const TermsConditions = ({ full_name }) => {
  const loading = false;
  const globalData = JSON.parse(retrieveData("QR_GLOBAL_DATA"));

  const restaurant = globalData?.[0];
  const restaurantEmail =
    restaurant?.restaurant_email || "support@uprestro.com";
  const restaurantMobile = restaurant?.restaurant_mobile_no || "";
  const restaurantName = restaurant?.restaurant_name || full_name;
  return (
    <>
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.heading}>Terms & Conditions</h1>

          <p style={styles.text}>
            <b>Last Updated: {new Date().toLocaleDateString()}</b>
          </p>

          <p style={styles.text}>
            Please read these Terms carefully. By accessing or using our website
            and services, you agree to comply with and be bound by these Terms &
            Conditions.
          </p>

          <h3 style={styles.subheading}>1. Introduction</h3>
          <p style={styles.text}>
            These Terms & Conditions (“Terms”) govern your use of the website,
            products, and services provided by{" "}
            <b>{restaurantName || full_name}</b> (“Company”, “we”, “our”, “us”).
            By interacting with our platform—including browsing, creating an
            account, placing an order, or making a payment—you agree to follow
            these Terms.
          </p>
          <p style={styles.text}>
            If you do not agree with any part of these Terms, you must
            discontinue using our website and services.
          </p>

          <h3 style={styles.subheading}>2. About Us</h3>
          <p style={styles.text}>
            <b>{restaurantName || full_name}</b> is an e-commerce brand offering
            quality lifestyle, personal, and family-oriented products. We are
            committed to seamless online shopping, reliable customer service,
            and transparent policies.
          </p>

          <h3 style={styles.subheading}>3. Definitions</h3>
          <ul style={styles.list}>
            <li>
              <b>CIVIL CODE</b> – Applicable Indian Civil & Consumer Protection
              Laws.
            </li>
            <li>
              <b>CLIENT PANEL</b> – Customer dashboard provided for order
              tracking.
            </li>
            <li>
              <b>COPYRIGHT LAW</b> – Indian Copyright Act and related IP laws.
            </li>
            <li>
              <b>TERMS</b> – These Terms & Conditions.
            </li>
            <li>
              <b>E-SERVICE</b> – Any online service provided by{" "}
              {restaurantName || full_name}.
            </li>
            <li>
              <b>SERVICE RECIPIENT</b> – Any user interacting with our services.
            </li>
            <li>
              <b>SERVICE PROVIDER</b> – {restaurantName || full_name}.
            </li>
          </ul>

          <h3 style={styles.subheading}>4. Terms and Conditions of Use</h3>

          <h4 style={styles.subHeadingSmall}>
            4.1 Intellectual Property Rights
          </h4>
          <p style={styles.text}>
            All content on this website—including text, images, logos, product
            descriptions, layouts, and code—is the exclusive property of{" "}
            <b>{restaurantName || full_name}</b>.
          </p>
          <p style={styles.text}>
            Users must not copy, reproduce, store, distribute, or use content
            for commercial purposes without written permission.
          </p>

          <h4 style={styles.subHeadingSmall}>4.2 Responsible and Lawful Use</h4>
          <p style={styles.text}>
            Users must not upload, post, or transmit unlawful, harmful, abusive,
            defamatory, fraudulent, or offensive content. Any misuse may lead to
            account restriction or legal action.
          </p>

          <h4 style={styles.subHeadingSmall}>4.3 Compliance</h4>
          <p style={styles.text}>
            {restaurantName || full_name} operates in compliance with Indian
            laws and reserves the right to take action against misuse or illegal
            activity.
          </p>

          <h4 style={styles.subHeadingSmall}>4.4 Personal Data</h4>
          <p style={styles.text}>
            We act as the Controller of personal data collected through this
            website. Data processing is governed by our <b>Privacy Policy</b>.
          </p>

          <h3 style={styles.subheading}>5. Disclaimer</h3>
          <p style={styles.text}>
            - All disputes are governed under Indian law.
            <br />
            - Website content is provided “as is”.
            <br />
            - We do not guarantee accuracy, completeness, or reliability of
            content.
            <br />
            - Information is not legal or professional advice.
            <br />
            - Users must exercise caution before downloading files.
            <br />- {restaurantName || full_name} is not liable for losses
            arising from website usage.
            <br />- Content may change without notice.
          </p>

          <h3 style={styles.subheading}>6. License to Use Website</h3>
          <p style={styles.text}>
            Users may browse and use the website for personal, non-commercial
            purposes.
          </p>
          <p style={styles.text}>
            You may <b>not</b>:
          </p>

          <ul style={styles.list}>
            <li>Republish content</li>
            <li>Sell, rent, or sublicense website materials</li>
            <li>Copy or redistribute content</li>
            <li>Exploit website content commercially</li>
          </ul>

          <h3 style={styles.subheading}>7. Hyperlinking to Our Content</h3>
          <p style={styles.text}>
            The following may link to our website without permission:
          </p>

          <ul style={styles.list}>
            <li>Government agencies</li>
            <li>Search engines</li>
            <li>News organizations</li>
            <li>Online directories</li>
            <li>Accredited businesses</li>
          </ul>

          <p style={styles.text}>
            Links must not mislead, deceive, imply false partnership, or damage
            the brand.
          </p>

          <h3 style={styles.subheading}>8. Communication</h3>
          <p style={styles.text}>
            By using our website, you consent to receive communications from us
            electronically via email, SMS, WhatsApp, or platform messages.
          </p>

          <h3 style={styles.subheading}>
            9. Feedback & User-Generated Content
          </h3>
          <p style={styles.text}>
            Users may submit reviews, comments, or feedback. By doing so, you
            grant
            {restaurantName || full_name} the right to use, publish, and
            distribute such content without compensation.
          </p>

          <p style={styles.text}>
            You agree that your submissions will not violate third-party rights,
            contain unlawful material, or include spam or misleading
            information.
          </p>

          <p style={styles.text}>
            {restaurantName || full_name} reserves the right to monitor, edit,
            or remove any content that violates these Terms.
          </p>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    padding: "40px",
    backgroundColor: "#f2f4f8",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0px 6px 20px rgba(0,0,0,0.1)",
    maxWidth: "900px",
  },
  heading: {
    color: "#2c3e50",
    marginBottom: "20px",
  },
  subheading: {
    color: "#2c3e50",
    marginTop: "25px",
    marginBottom: "10px",
  },
  subHeadingSmall: {
    color: "#2c3e50",
    marginTop: "15px",
    marginBottom: "8px",
  },
  text: {
    fontSize: "16px",
    color: "#34495e",
    lineHeight: "1.6",
    marginBottom: "12px",
  },
  list: {
    marginLeft: "20px",
    marginBottom: "10px",
    color: "#34495e",
  },
};

export default TermsConditions;
